// Zweck: Typisierte API-Aufrufe zum Lesen und Erledigen von AB-Aufgaben.
// Kontext: #1476; Doku-Phasen langfristig mit Admin-Portal vereinheitlichen.
// Stand: 2026-10-19
import one360 from './one360';
import type { CompleteOrderTask, OrderTasks } from '../../interfaces/orderTasks';
const path = (projectId: string) => `/api/v1/ops/projects/${encodeURIComponent(projectId)}/order-tasks`;
export const getOrderTasks = (projectId: string): Promise<OrderTasks> => one360.get<OrderTasks>(path(projectId));
export const completeOrderTask = (projectId: string, taskId: string, change: CompleteOrderTask): Promise<OrderTasks> =>
  one360.post<OrderTasks>(`${path(projectId)}/${encodeURIComponent(taskId)}/complete`, change);
